import { render, staticRenderFns } from "./MessageItemMessageThirdPartyServices.vue?vue&type=template&id=0912e26e"
import script from "./MessageItemMessageThirdPartyServices.vue?vue&type=script&lang=js"
export * from "./MessageItemMessageThirdPartyServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports